import React, { useState, useEffect } from "react";
import { Form, Button } from "semantic-ui-react";
import { useLocation } from "react-router-dom";
import { useSiteConfig } from "../../../hooks";
import { verifyTableAccessApi } from "../../../api/table";
import { saveTableAccess } from "../../../api/tableAccess";
import "./SelectTable.scss";

// Entrada manual, para quien no puede escanear el QR: solo el código impreso
// debajo del QR. Con ambientes, "Mesa 3" se repite (Salón y Terraza); el código
// identifica la mesa y además evita pedir en una mesa ajena.
export function SelectTable(props) {
  const { history } = props;
  const location = useLocation();
  const [code, setCode] = useState("");
  const [error, setError] = useState(location.state?.error || null);
  const { siteConfig, getSiteConfig } = useSiteConfig();

  useEffect(() => {
    getSiteConfig();
  }, []);

  const onSubmit = async () => {
    setError(null);
    if (!code.trim()) {
      setError("Ingresa el código impreso debajo del QR de tu mesa");
      return;
    }

    const cleanCode = code.trim().toUpperCase();
    const table = await verifyTableAccessApi(null, cleanCode);
    if (table) {
      saveTableAccess(table.number, cleanCode);
      history.push(`/client/${table.number}`);
    } else {
      setError("El código no es correcto. Revisa el que está debajo del QR de tu mesa.");
    }
  };

  return (
    <div className="select-table">
      <div className="select-table__content">
        <h1>
          Bienvenido
          <br />
          {siteConfig?.site_name || "iCard"}
        </h1>
        <h2>Escanea el código QR de tu mesa</h2>
        <p className="select-table__content-hint">
          o ingresa el código impreso debajo del QR:
        </p>

        <Form onSubmit={onSubmit}>
          <Form.Input
            placeholder="Código (ej: K7P2QM)"
            value={code}
            maxLength={12}
            autoCapitalize="characters"
            autoComplete="off"
            onChange={(_, data) => setCode(data.value.toUpperCase())}
          />

          <Button primary fluid>
            Entrar
          </Button>
        </Form>

        <p className="select-table__content-error">{error}</p>
      </div>
    </div>
  );
}
